import type { AbTestCampaignNameEnum } from '@models/ab-test-models';

import { createAction, props } from '@ngrx/store';

interface abtestValue {
  value: string;
}

export const initABTestCampaigns = createAction('[AbTest] Init ab test campaigns');
export const initABTestCampaignsSuccess = createAction(
  '[AbTest] Init ab test campaigns success',
  props<{ abtestValues: Record<AbTestCampaignNameEnum, abtestValue> }>()
);
